import { useI18n } from 'vue-i18n'

export const useSortMenu = () => {
	const { t } = useI18n()

	return [
		{
			id: 'name',
			name: t('filter.songName.aö')
		},
		{
			id: '-name',
			name: t('filter.songName.öa')
		},
		{
			id: 'artist_name',
			name: t('filter.artistName.aö')
		},
		{
			id: '-artist_name',
			name: t('filter.artistName.öa')
		},
		{
			id: 'latest',
			name: t('filter.latest')
		},
		{
			id: 'top',
			name: t('filter.top')
		},
		{
			id: 'hot',
			name: t('filter.hot')
		},
		{
			id: 'duration',
			name: t('filter.duration.longShort')
		},
		{
			id: '-duration',
			name: t('filter.duration.shortLong')
		}
	]
}
